export var DISPLAY_FORMAT = 'L';
export var ISO_FORMAT = 'YYYY-MM-DD';
export var ISO_MONTH_FORMAT = 'YYYY-MM';
export var START_DATE = 'startDate';
export var END_DATE = 'endDate';
export var HORIZONTAL_ORIENTATION = 'horizontal';
export var VERTICAL_ORIENTATION = 'vertical';
export var VERTICAL_SCROLLABLE = 'verticalScrollable';
export var ANCHOR_LEFT = 'left';
export var ANCHOR_RIGHT = 'right';
export var DAY_SIZE = 39;
export var BLOCKED_MODIFIER = 'blocked';
export var WEEKDAYS = [0, 1, 2, 3, 4, 5, 6];
export var DEFAULT_DISPLAY_FORMAT = 'Do MMMM YYYY';
export var SUPPORTED_DATE_FORMATS = ['YYYY-MM-DD', 'YYYY/MM/DD', 'YYYY-M-D', 'YYYY/M/D', 'DD-MM-YYYY', 'DD/MM/YYYY', 'D-M-YYYY', 'D/M/YYYY'];